/**
 * Associations app — client constants (mirrors api/constants/associations.js).
 */

export const ASSOCIATIONS_APP_SLUG = 'associations';

export const ASSOCIATION_TYPES = Object.freeze({
  VENDOR_PARTNER: 'vendor_partner',
  PROGRAM_SITE: 'program_site',
  TRACK: 'track'
});

export const VENDOR_PARTNER_ASSOCIATION_TYPE = ASSOCIATION_TYPES.VENDOR_PARTNER;

export const DEFAULT_ASSOCIATION_TYPE_DEFS = Object.freeze([
  {
    type: ASSOCIATION_TYPES.VENDOR_PARTNER,
    label: 'Vendor partner',
    hint: 'Vendor track / FA cohort linked to this student — not enrollment in that team.'
  },
  {
    type: ASSOCIATION_TYPES.PROGRAM_SITE,
    label: 'Program site',
    hint: 'Program site or location team.'
  },
  {
    type: ASSOCIATION_TYPES.TRACK,
    label: 'Track / schedule',
    hint: 'Track or schedule grouping.'
  }
]);

export const ASSOCIATION_TYPE_LABELS = Object.freeze(
  DEFAULT_ASSOCIATION_TYPE_DEFS.reduce((acc, d) => {
    acc[d.type] = d.label;
    return acc;
  }, {})
);

export function normalizeAssociationType(type) {
  const t = String(type || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  return t || null;
}

export function parseEnabledAssociationTypes(metadata) {
  const raw = metadata?.enabled_association_types;
  const defsByType = new Map(DEFAULT_ASSOCIATION_TYPE_DEFS.map((d) => [d.type, d]));
  if (!Array.isArray(raw) || !raw.length) {
    return DEFAULT_ASSOCIATION_TYPE_DEFS.map((d) => ({ type: d.type, label: d.label }));
  }
  return raw
    .map((item) => {
      if (typeof item === 'string') {
        const type = normalizeAssociationType(item);
        if (!type) return null;
        return { type, label: defsByType.get(type)?.label || type };
      }
      if (item && typeof item === 'object' && item.type) {
        const type = normalizeAssociationType(item.type);
        if (!type) return null;
        return { type, label: String(item.label || defsByType.get(type)?.label || type) };
      }
      return null;
    })
    .filter(Boolean);
}

export function buildAssociationsApiUrl(userGroupsPeriodsId, { associationType, includeEnded } = {}) {
  const params = new URLSearchParams({ user_groups_periods_id: String(userGroupsPeriodsId) });
  if (associationType) params.set('association_type', associationType);
  if (includeEnded) params.set('include_ended', 'true');
  return `/api/associations?${params.toString()}`;
}
